import { createStyles, fade, makeStyles } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    chipRoot: {
      backgroundColor: fade(colorsPalette.violetAnalyticsToggle, 0.3),
    },
    chipLabel: {
      fontSize: 16,
      lineHeight: 1,
      color: colorsPalette.gray,
    },
    chipDeleteIcon: {
      width: 16,
      height: 16,
      padding: 4,
      borderRadius: '50%',
      color: colorsPalette.white,
      '&:hover': {
        backgroundColor: fade(colorsPalette.white, 0.08),
      },
    },
  }),
);

export default useStyles;
